export interface ProviderSettingsResponse {
  name?: string;
  email?: string;
  specialtyName?: string;
  siteName?: string;
  ehrName?: string;
  mixpanelSettings?: { app: string; token: string }[];
  mode?: string;
  practiceName?: string;
  appSettings?: {
    providerResponse?: {
      inactivityLogoutTime?: number;
      glassPermutationKey?: string;
      clientDataLakeUpload?: boolean;
      userSettings?: UserSettings;
      nextPasswordResetInstant?: {
        nano?: number;
        epochSecond?: number;
      };
    };
  };
}

export interface UserSettings {
  pinEnabled?: boolean;
  asrLatencyThreshold?: number;
  autoAudioContinuity?: boolean;
  enabledNudges?: boolean;
  transcriptionFlow?: string;
  recordingFeatureEnabled?: boolean;
  remoteStateIntegrated?: boolean;
  markdownSupport?: boolean;
  allowScribeInitiatedRecording?: boolean;
  remoteStateIntegrated2?: boolean;
  edEnabled?: boolean;
  noteTemplatesEnabled?: boolean;
  providerAdmin?: boolean;
  hcaHardStops?: boolean;
  inactivityTimeoutInMinutes?: number;
}

export interface ProviderResetPasswordInput {
  newPassword: string;
}

export enum ProviderProductOffering {
  GO_ASSIST = 'Go Assist',
  GO_UPLOAD = 'Go Upload',
  GO_BASIC = 'Go Basic',
}

export enum ProviderProductOfferingStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export interface ProviderProductOfferingResponse {
  message: string;
  name: ProviderProductOffering;
  packageName: string;
  status: string;
  settings: ProviderProductOfferingSettings;
}

export interface ProviderProductOfferingSettings {
  allowedNotesCount: number;
  associatedAccountCount: number;
  scribeAssociationEnabled: boolean;
  slaDueTimeMinutes: number;
  unlimitedNotesAllowed: boolean;
  disableSendToMdsForUploadOnly: boolean;
}

export interface ProviderIntegrationInfo {
  ehrEnabled: boolean;
  ehrIntegrationEnabled: boolean;
  ehrUploadNoteEnabled: boolean;
  hasActiveIntegrations: boolean;
}

export interface Clinician {
  id: string;
  guid: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface ClinicianInfo {
  data?: Clinician[];
  totalCount?: number;
}
